import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { FormArray, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import {
  DocumentPayment,
  PaymentCapacity,
  PaymentDocumentInfo,
  Petition,
  DocumentVersionValidationInvoice,
  DocumentNewVersion,
  Document,
  LogsNav
} from 'src/app/interfaces/interfaces.index';
import { DataTableEsp } from 'src/app/shared/config/config';
import { firstValueFrom, Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { Router } from '@angular/router';
import { DocumentService } from '../../../services/document.service';
import { swalError, swalDesition, swalSuccess } from 'src/app/shared/config/swalCommon';
import Swal from 'sweetalert2';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { createTabName, getBase64, getFileName, extractBase64 } from 'src/app/shared/config/commons';
import { LogsService, UserService, PersonaService, PeticionService } from 'src/app/services/services.index';

@Component({
  selector: 'app-control-documental',
  templateUrl: './control-documental.component.html',
  styleUrls: ['./control-documental.component.css']
})
export class ControlDocumentalComponent implements OnInit {

  dtOptions: DataTables.Settings = {};
  dtLanguage: {} = DataTableEsp;
  dtTrigger = new Subject<void>();
  @ViewChild(DataTableDirective, { static: false }) dtElement: DataTableDirective;

  documentos: DocumentPayment[] = [];
  docs: DocumentPayment[] = [];
  actPetition: Petition;
  capacidad: PaymentCapacity;
  actualRequest: PaymentDocumentInfo;
  payment: number;
  documentFilter: Document[] = [];
  valid = true;
  forma: UntypedFormGroup;
  respuesta: any;
  @Input() public documentsCorrection;
  @Input() public documentType: string;
  documentValidation: DocumentVersionValidationInvoice;
  userId: number;
  getFileName = getFileName;
  createTabName = createTabName;
  personType = "Natural"

  constructor(
    public router: Router,
    private SpinnerService: NgxSpinnerService,
    private documentService: DocumentService,
    public activateModal: NgbActiveModal,
    private logsService: LogsService,
    private userService: UserService,
    private personaService: PersonaService,
    private peticionService: PeticionService
  ) {
    this.dtOptions = {
      retrieve: true,
      order: [[0, 'asc']],
      columnDefs: [],
      language: this.dtLanguage,
      pagingType: 'full_numbers',
    };

    this.SpinnerService.show();
    this.forma = new UntypedFormGroup({});
    this.actPetition = (JSON.parse(sessionStorage.getItem('selPetition'))) as Petition;
    this.capacidad =  (JSON.parse(sessionStorage.getItem('capacidadPago'))) as PaymentCapacity;
    this.userId = this.userService.user.id;
    setTimeout(() => this.getReviewDocs(), 60)
  }

  async ngOnInit() {
    this.addLogsNav();

    if(this.userService.currentPetitionUserId == undefined)
    {
      this.personType = "Juridical"
    }
    else
    {
      await firstValueFrom(this.personaService.getPeopleByUser(this.userService.currentPetitionUserId ?? this.userService.user.id)).then(res => {
        if(res.typeOfIdentity.trim() === "N" || res.typeOfIdentity.trim() === "NIT") {
          this.personType = "Juridical"
        }
      });
    }
  }

  addLogsNav(){
    const logNav: LogsNav = {
      logType: 'Log de Navegación',
      visitedPage: location.href,
      userId: this.userService.user.id,
      petitionId: 0,
      stepCompleted: ''
    };

  }

  getReviewDocs() {
    this.SpinnerService.hide();
    this.documentFilter = this.documentsCorrection;
    if (this.documentsCorrection !== null) {
      this.documentFilter.forEach(x => {
        this.forma.addControl(createTabName(x.baseDocument.docName), new UntypedFormControl(null, Validators.required));

        if(this.documentFilter.length == 1)
        {
          this.peticionService.getPetitionById(x.petitionId).subscribe(res => {
            sessionStorage.setItem('selPetition', JSON.stringify(res));
            sessionStorage.setItem('docId', JSON.stringify(x.id));
          })
        }

      });
      this.dtTrigger.next();
    }
  }

  goToFormUrl = (documentName: string) => {
    let url = '';

    if (documentName == 'Pagaré') {
      if(this.personType != "Juridical")
        url = '/pagare';
      else
        url = '/estudio-capacidad-pago';
    }
    if (documentName == 'Seguro de vida') url = '/seguro-de-vida';
    if (documentName == 'Carta de compromiso') url = '/carta-compromiso';

    this.router.navigate([url]);
    sessionStorage.setItem('activateCorrectionDoc', JSON.stringify(true));
    this.activateModal.close();
  };

  saveDocuments() {
    if(this.documentos.length>=1){
        Swal.fire(
          swalDesition(
            `${(this.documentos.length == 1) ? 'Subir archivo' : 'Subir archivos'}`,
            `${(this.documentos.length == 1) ? '¿Desea subir este archivo?' : '¿Desea subir estos archivos?'}`
          )).then(res => {
          if (res.value) {
            this.SpinnerService.show();
            // Limpiar los attachments removiendo el prefijo data:application/pdf;base64,
            this.documentos.forEach(doc => {
              if (doc.attachment) {
                doc.attachment = extractBase64(doc.attachment);
              }
            });
            if (this.documentType == 'invoice') {
              this.documentService.sendDocumentVersion(this.documentos).subscribe(
                () => {
                  this.SpinnerService.hide();
                  Swal.fire(swalSuccess('Documento(s) actualizado(s) correctamente', 'Debe esperar a que el analista/auxiliar revise los documentos'));
                  this.activateModal.close();
                },
                err => this.handleError('No se pudo subir el/los documento(s)')
              );
            } else if (this.documentType == 'enrollment') {
              this.documentService.sendDocumentEnrollmentVersion(this.documentos).subscribe(
                () => {
                  this.SpinnerService.hide();
                  Swal.fire(swalSuccess('Documento(s) actualizado(s) correctamente', 'Debe esperar a que el auxiliar revise los documentos'));
                  this.activateModal.close();
                },
                err => this.handleError('No se pudo subir el/los documento(s)')
              );
            }
          }
        });
      }else{
         Swal.fire(swalSuccess('Debe cargar por lo menos un documento'));

      }
  }




  handleError = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err?.userMessage));
  }

  handleErrorSico = (err) => {
    this.SpinnerService.hide();
    Swal.fire(swalError('Ha ocurrido un error', err));
  }

  assignAttachment = (files: FileList, i: number, documentName: string, documentId: number) => {
    this.forma;
    if(files[0]?.type !== "application/pdf" || files[0].size > 2000000) {
      if(files[0]) Swal.fire({ title: "Formato y/o peso inválido", text: "Por favor solo cargar formatos PDF y máximo 2MB por archivo", icon: 'info' });
      if(this.documentos[i]) this.documentos[i].attachment = null;
      (<HTMLInputElement>document.getElementById(`file${i}`)).value = null;
      this.forma.controls[createTabName(documentName)]?.setValue(null);
      return;
    }

    if (this.documentos[i] === undefined) {
      if (this.actPetition == undefined) {
        let document: DocumentNewVersion = {
          attachment: null,
          documentName: documentName,
          documentStatus: 'Requiere corrección',
          documentId: documentId,
          documentType: this.documentType,
          userId: this.userId
        };
        this.documentos[i] = document;
      } else {
        let document: DocumentNewVersion = {
          attachment: null,
          documentName: documentName,
          petitionId: this.actPetition.id,
          documentStatus: 'Requiere corrección',
          documentId: documentId,
          documentType: this.documentType,
          userId: this.userId
        };
        this.documentos[i] = document;
      }
    }
    (files.length > 0) ? getBase64(files[0])
      .then((val: string) => {
        this.documentos[i].attachment = val;
        this.forma.controls[createTabName(documentName)].setValue(this.documentos[i]);
      }) : this.documentos[i].attachment = null;
  }

}
